import React, { useState } from 'react';
import { Row, Col } from '@components/util_grid/grid';
import { ProductImage, TitleAndSubtitle, Metabar, Excerpt, QuantityInput } from 'audamatic-ui';
import ProductModal from './_product-modal/component';
import store from '@utils/store';
import HistoryToggle from '@components/ui_history_toggle/component';
import PropTypes from 'prop-types';
import Text from '@text';
import TypeSet from '@components/base_typeset/component';
import { numFormatToCurrency } from '@utils';
import './styles.scss';


const AnkeilerCampaign = (props) => {
  const { item, productHistory, updateCampaignItemQuantity } = props;
  const { title, ean, releaseDate,  type, additionalInformation, description, cartQuantity = 1, suggestedQuantity, priceInformation, discountPercentage, genre, persons, links } = item;
  const { purchasePrice, salePrice } = priceInformation;

  const [quantity, setQuantity] = useState(cartQuantity);

  const updateQuantity = (newValue) => {
    setQuantity(newValue);
    const url = links[0].href;
    updateCampaignItemQuantity({
      quantity: newValue,
      url,
    });
  };

  const openProductModal = () => {
    store.modal.openModal('popup', 'center', {
      component: <ProductModal product={item} store={store} />,
    });
  };

  const getPersons = persons?.map(person => person.name).join(', ');

  const metaData = [
    <div className="ean">{ean}</div>,
    !!releaseDate && <div className="release-date">{releaseDate}</div>,
    !!type && <div className="producttype">{type}</div>,
    !!genre && <div className="genre"><Text>product.metadata.genre</Text>: {genre}</div>,
    additionalInformation.map((infoObject) => {
      return Object.entries(infoObject).map(([key, value]) => {
        if (!value) {
          return null;
        }
        const confirmations = ['ja', 'Ja', 'nee', 'Nee'];
        let color = '';
        let bold = false;
        if (confirmations.includes(value)) {
          color = 'cta';
          bold = true;
        }
        return (
          <span key={`infoline-${key}`}>
            {key}: <TypeSet scale="0" color={color} bold={bold}>{value.toString()}</TypeSet>
          </span>
        );
      });
    }),
  ];

  return (
    <div className="ankeiler-campaign">
      <Row>
        <Col xs={12} className="visible-xs">
          <div className="history-wrap">
            <HistoryToggle
              product={item}
              productHistory={productHistory}
            />
          </div>
        </Col>
        <Col xs={4} sm={2} className="image-column">
          <div className="ankeiler">
            <div className="image wrapper" onClick={openProductModal}>
              <ProductImage
                product={item}
                maxHeight={149}
                data-test-id="productImage"
              />
            </div>
          </div>
        </Col>
        <Col xs={8} sm={10}>
          <Row className="title-row">
            <Col xs={12} sm={8}>
              <div className="haslink">
                <TitleAndSubtitle
                  title={title}
                  subtitle={getPersons}
                />
              </div>
            </Col>
            <Col xs={12} sm={4}>
              <div className="history-wrap hidden-xs">
                <HistoryToggle
                  product={item}
                  productHistory={productHistory}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={7} md={8} className="details-column">
              <div className="meta-data">
                <Metabar>
                  {metaData}
                </Metabar>
              </div>
              <Excerpt
                text={description}
                maxLines={3}
                label1={<Text>common.link.readmore</Text>}
                label2={<Text>common.link.readless</Text>}
              />
            </Col>
            <Col xs={12} sm={5}md={4}>
              <div className="price-information">
                {!!discountPercentage && <div><span className="price-label"><Text>signups.discount</Text>: </span>{discountPercentage}%</div>}
                {!!purchasePrice.amount && (
                  <div><span className="price-label">{purchasePrice.label}: </span>{numFormatToCurrency(purchasePrice.amount)}</div>
                )}
                {!!salePrice.amount && (
                  <div><span className="price-label">{salePrice.label}: </span>{numFormatToCurrency(salePrice.amount)}</div>
                )}
              </div>
              {!!suggestedQuantity && (
                <div className="suggested-quantity">
                  <Text>signups.suggested-quantity</Text>: {suggestedQuantity}
                </div>
              )}
              <QuantityInput
                changeQuantity={newValue => updateQuantity(newValue)}
                value={quantity}
                minQuantity={0}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
AnkeilerCampaign.propTypes = {
  item: PropTypes.object,
  productHistory: PropTypes.object,
  updateCampaignItemQuantity: PropTypes.func,
};

export default AnkeilerCampaign;
